import { ChevronLeft, ChevronRight } from 'lucide-react'

interface HeroControlsProps {
  total: number
  index: number
  onPrev: () => void
  onNext: () => void
  onGoTo: (i: number) => void
}

export function HeroControls({ total, index, onPrev, onNext, onGoTo }: HeroControlsProps) {
  return (
    <>
      <button
        onClick={onPrev}
        aria-label="Trước"
        className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/80 hover:bg-white text-brand-600 flex items-center justify-center shadow-card transition z-20"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={onNext}
        aria-label="Sau"
        className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/80 hover:bg-white text-brand-600 flex items-center justify-center shadow-card transition z-20"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2 z-20">
        {Array.from({ length: total }).map((_, i) => (
          <button
            key={i}
            onClick={() => onGoTo(i)}
            aria-label={`Slide ${i + 1}`}
            className={[
              'h-2 rounded-full transition-all',
              i === index ? 'w-8 bg-brand-600' : 'w-2 bg-white/80 hover:bg-white',
            ].join(' ')}
          />
        ))}
      </div>
    </>
  )
}
